export default "__VITE_ASSET__qij7ImFF__"